import { type Theme } from '@pixee/design-system'
import { match } from 'ts-pattern'
import { type EnvironmentData } from '../utils/hooks/get-environment-data.ts'
import * as styles from './navigation-bar.css.ts'

export type NavBarBrandLogoProps = {
  environmentData: EnvironmentData
  theme: Theme
}

export const NavBarBrandLogo: React.FC<NavBarBrandLogoProps> = ({ environmentData, theme }) => (
  <div className={styles.navBarBrand}>
    {match(environmentData.name)
      .with('ntt', () => (
        <img
          src={environmentData.logoIconHref}
          alt={environmentData.logoIconAlt}
          style={{ height: '28px', borderRadius: '50%' }}
        />
      ))
      .otherwise(() => (
        <img
          src={theme === 'dark' ? '/Pixee_PrimaryLogo_Light.svg' : '/Pixee_PrimaryLogo_Dark.svg'}
          alt={environmentData.logoIconAlt}
          height={28}
        />
      ))}
  </div>
)
